import { render, staticRenderFns } from "./userDashboardMembercard.vue?vue&type=template&id=2bf3f662&scoped=true"
import script from "./userDashboardMembercard.vue?vue&type=script&lang=js"
export * from "./userDashboardMembercard.vue?vue&type=script&lang=js"
import style0 from "./userDashboardMembercard.vue?vue&type=style&index=0&id=2bf3f662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3f662",
  null
  
)

export default component.exports